<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect @change="setFacility"></BaseFacilitySelect>
    </div>
    <div class="card">
      <div class="card-header"><strong>Collect consent</strong></div>
      <div class="card-body" v-if="isEmployer">
        <div >
          <strong>
            Consent is required annually after the beginning of each respiratory season (July 1). Employees can access and complete the consent form in one of two ways:
          </strong>
          <ol>
            <li>
              Sending the consent form to the employee by typing their work email address in the text box below.
            </li>
            <li>
              Asking the employee to navigate to the consent form on their own using
              <a v-if="this.$store.state.selectedFacility"
                 v-bind:href="`${this.url}` + '/employee?orgCode=' + this.submission.orgCode"
                 target="_blank"
                 rel="noopener noreferrer">
                <u>{{ 'VaxCheck Program Consent Form ' }}</u>
                <b-icon-box-arrow-up-right aria-hidden="true"></b-icon-box-arrow-up-right>
              </a>
              <p class="p-1" >
                <span v-if="!this.$store.state.selectedFacility"><em style="color: #c70000;">Please select a facility.</em></span>
                <span v-if="this.$store.state.selectedFacility"><em style="color: #c70000;">You must share the entire URL for the consent form.</em></span>
                <em style="color: #2c3e50"><a v-if="this.$store.state.selectedFacility"> {{ '(' + this.url + '/employee?orgCode=' + this.submission.orgCode + ')' }} </a></em>
              </p>
            </li>
          </ol>
          <p>
            For more guidance on sharing the consent form with employees, email <a href="mailto:health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
          </p>
        </div>
        <br>
        <div class="row-cols-md-1">
          <div>
            <b-form-textarea
              id="empEmails"
              v-model="submission.emails"
              placeholder="Enter employee email addresses here (separated by semicolon)"
              rows="4"
              max-rows="5"
              no-auto-shrink
              aria-label="Enter employee email addresses here (separated by semicolon)"
            >
            </b-form-textarea>
          </div>
          <br>
          <div>
            <b-button class="d-block p-2 bg-mdh text-white" @click="submit">
              Send Consent Form
            </b-button>
          </div>
        </div>
      </div>
      <div class="card-body" v-if="isChildCareCenter">
        <div>
          <strong>
            Consent is required annually. Parents/guardians can access and complete the consent form in one of two ways:
          </strong>
          <ol>
            <li>
              Sending the consent form to the parent/guardian by typing their email address in the text box below.
            </li>
            <li>
              Asking the parent/guardian to navigate to the consent form on their own using
              <a v-if="this.$store.state.selectedFacility"
                 v-bind:href="`${this.url}` + '/childcare?orgCode=' + this.submission.orgCode"
                 target="_blank"
                 rel="noopener noreferrer">
                <u>{{ 'VaxCheck Program Consent Form' }}</u>
                <b-icon-box-arrow-up-right aria-hidden="true"></b-icon-box-arrow-up-right>
              </a>.
              <p class="p-1" >
                <span v-if="!this.$store.state.selectedFacility"><em style="color: #c70000;">Please select a facility.</em></span>
                <span v-if="this.$store.state.selectedFacility"><em style="color: #c70000;">You must share the entire URL for the consent form.</em></span>
                <em style="color: #2c3e50"><a v-if="this.$store.state.selectedFacility"> {{ '(' + this.url + '/childcare?orgCode=' + this.submission.orgCode + ')' }} </a></em>
              </p>
            </li>
          </ol>
          <p>
            For more guidance on sharing the consent form with parents/guardians, email <a href="mailto:health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
          </p>
        </div>
        <br>
        <div class="row-cols-md-1">
          <div>
            <b-form-textarea
              id="empEmails"
              v-model="submission.emails"
              placeholder="Enter email addresses here (separated by semicolon)"
              rows="4"
              max-rows="5"
              no-auto-shrink
              aria-label="Enter email addresses here (separated by semicolon)"
            >
            </b-form-textarea>
          </div>
          <br>
          <div>
            <b-button class="d-block p-2 bg-mdh text-white" @click="submit">
              Send Consent Form
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>


<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import axios from "axios";

export default {
  components: {BaseFacilitySelect},

  data: () => ({
    url: `${process.env.VUE_APP_CONSENT_FORM_URL}`,
    submission: {
      emails: '',
      orgCode: '',
      orgName: '',
      orgType: ''
    },
    user: {
      id: "",
      iamId: "",
      emailAddress: "",
      firstName: "",
      jobTitle: "",
      lastName: "",
      middleName: "",
      phoneNumber: "",
      requestStatus: "",
      org: "",
      primary: Boolean,

      userRole: [],
      url: `${process.env.VUE_APP_API_BASE_URL}/request/update`
    },
    isChildCareCenter: false,
    isEmployer: false
  }),

  mounted() {
    this.setFacility()
    this.checkOrgType()
  },

  methods: {
    setFacility() {
      if(this.$store.state.selectedFacility){
        this.submission.orgCode = this.$store.state.selectedFacility.id     // facility_id
        this.submission.orgName = this.$store.state.selectedFacility.facilityName
      }
    },

    checkOrgType() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
        if (response.data.intendedUse === 'Certified child care center') {
          this.isChildCareCenter = true
          this.submission.orgType = 'childcare'
        } else {
          this.isEmployer = true
          this.submission.orgType = 'employer'
        }
      })
    },

    clearEmails() {
      this.submission.emails = ''
    },

    submit() {
      if (this.$store.state.selectedFacility) {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/consent`, this.submission)
          .then(response => {
            if (response.status === 200) {
              this.clearEmails()
              this.showRootToast("Success", "Consent form has been sent.", "success");
            }
          })
          .catch(() => {
            this.showRootToast("Error", "Error sending consent form. Please make sure emails are formatted correctly.", "danger");
            return Promise.reject('Email string invalid.')
          })
      } else {
          this.showRootToast("Error", "Please select a facility.", "danger");
      }

    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  },
}

</script>


<style scoped>
ol {
  list-style-type: decimal;
  padding-left: 1em;
}
li {
  display: list-item;
}

</style>
